export default [
  {
    path: '/compras',
    name: 'orders',
    component: () => import(/* webpackChunkName: "orders" */ './List.vue'),
    meta: { auth: true }
  },
  {
    path: '/compras/novo',
    name: 'orders/novo',
    component: () => import(/* webpackChunkName: "orders" */ './Add.vue'),
    meta: { auth: true }
  },
]
